// @flow
import * as React from 'react';
import { Link } from 'react-router-dom';
import styles from './ChannelList.scss';
import random from 'lodash/random';
import { EmptyCard, Card } from 'components';

type ChannelCountProps = {
  count?: ?number | Error,
  ugctype?: string,
};
class ChannelCount extends React.PureComponent<ChannelCountProps> {
  render() {
    const { count, ugctype = 'Item' } = this.props;
    let countText;
    let label = `${ugctype}s`;

    if (count == null) {
      countText = <span className={styles.channelListCountLoader}>&nbsp;</span>;
      label = (
        <span
          className={styles.channelListCountLoader}
          style={{ paddingLeft: '2.2em' }}
        >
          &nbsp;
        </span>
      );
    } else if (typeof count === 'number') {
      countText = count;
      label = count === 1 ? ugctype : label;
    } else {
      countText = 'x';
    }

    return (
      <div className="pv2 bg-light-gray nowrap">
        <span className="db f3 tc b lh-solid brandon tracked-tight Channel__count">
          {countText}
        </span>
        <span className="f6 gray db tc tracked-tight">{label}</span>
      </div>
    );
  }
}

type ListItemLayoutProps = {
  children: [React.Node, React.Node] | [React.Node, React.Node, React.Node],
  pt?: number,
  pb?: number,
  bb?: boolean,
};
const ListItemLayout = (props: ListItemLayoutProps) => {
  const [count, main, controls] = React.Children.toArray(props.children);
  const { pt = 3, pb = 3, bb = true } = props;

  return (
    <div
      className={`flex items-center w-100 ChannelList__item b--moon-gray pt${pt} pb${pb} ${
        bb ? 'bb' : ''
      }`}
    >
      <div className="flex-none ChannelList__item__count">{count}</div>
      <div className="flex-auto mh3">{main}</div>
      {controls && <div className="flex-none">{controls}</div>}
    </div>
  );
};

type ListItemProps = {
  path: string,
  count: ?number,
  children?: React.Node,
  channelName: string,
  requestChannelStats: string => void,
  label: string,
  description: string,
  hasWorklist?: boolean,
  ugctype: string,
};

class ListItem extends React.Component<ListItemProps> {
  componentDidMount() {
    this.props.requestChannelStats(this.props.channelName);
  }

  render() {
    const {
      label,
      description,
      path,
      count,
      children,
      hasWorklist,
      ugctype,
    } = this.props;

    const listItemProps = hasWorklist === true ? { pb: 0, bb: false } : null;

    return (
      <ListItemLayout {...listItemProps}>
        <ChannelCount count={count} ugctype={ugctype} />
        <React.Fragment>
          <h3 className="mt0 mb0">
            <Link to={path} className="no-underline Channel__label">
              {label}
            </Link>
          </h3>
          <span className="gray Channel__description">{description}</span>
        </React.Fragment>
        {children}
      </ListItemLayout>
    );
  }
}

type WorkListItemProps = {
  path: string,
  count: ?number,
  channelName: string,
  requestChannelStats: string => void,
  description: string,
};

class WorkListItem extends React.Component<WorkListItemProps> {
  componentDidMount() {
    this.props.requestChannelStats(this.props.channelName);
  }

  render() {
    const { description, path, count } = this.props;
    const countText =
      typeof count === 'number' ? (
        count
      ) : count instanceof Error ? (
        '?'
      ) : (
        <span
          className={styles.channelListCountLoader}
          style={{ lineHeight: 0.6 }}
        >
          &nbsp;
        </span>
      );

    return (
      <ListItemLayout pt={2}>
        <div style={{ width: '2.2em' }}> </div>
        <div className="flex items-center">
          <span
            className="db f3 tc b brandon tracked-tight bg-light-gray nowrap mr3 br-pill lh-solid pv1"
            style={{ width: 50, fontSize: '1.4rem' }}
          >
            {countText}
          </span>
          <div>
            <h3 className="mt0 mb0">
              <Link to={path} className="no-underline Channel__label">
                Worklist
              </Link>
            </h3>
            <span className="gray Channel__description">{description}</span>
          </div>
        </div>
      </ListItemLayout>
    );
  }
}

const ListItemPending = () => (
  <ListItemLayout>
    <ChannelCount />
    <React.Fragment>
      <div
        className="mt0 mb1 bg-light-blue h1"
        style={{ width: random(15, 30) + '%' }}
      >
        &nbsp;
      </div>
      <div
        className="bg-light-gray mt2 h1"
        style={{ width: random(50, 70) + '%' }}
      >
        &nbsp;
      </div>
    </React.Fragment>
  </ListItemLayout>
);

type Props = {
  children?: any,
  header?: ?string,
};

const List = (props: Props) => {
  const { children, header } = props;
  if (React.Children.count(children) === 0) {
    return (
      <EmptyCard
        title="No Channels"
        message="Seems like your channels have not been configured, contact PowerReviews Support for help."
      />
    );
  }

  return (
    <section className="mb4">
      {header && (
        <header className="gray">
          <h1 className="mt0 mb3 gray normal f5 sans-serif">{header}</h1>
        </header>
      )}
      <Card verticalSpacing={0}>
        <div className="pv3">
          <div className="mh4 ChannelList" data-translate={true}>
            {children}
          </div>
        </div>
      </Card>
    </section>
  );
};

List.Item = ListItem;
List.WorkListItem = WorkListItem;
List.ItemPending = ListItemPending;

export default List;



// WEBPACK FOOTER //
// ./src/containers/channels/ChannelList.js